// extracted by mini-css-extract-plugin
export default {"badge":"TypeBadge_badge__7K2su","keepBadge":"TypeBadge_keepBadge__Wo95-","weekendBadge":"TypeBadge_weekendBadge__Gaxb7","permanentBadge":"TypeBadge_permanentBadge__soqh-"};